import React from 'react';
import { Container } from './ui/Container';
import { Star, Quote } from 'lucide-react';
import { Button } from './ui/Button';
interface TestimonialProps {
  name: string;
  image: string;
  text: string;
}
function TestimonialCard({
  name,
  image,
  text
}: TestimonialProps) {
  return <div className="bg-[#3f3f3f] p-8 rounded-lg shadow-lg relative flex flex-col h-full border-t-4 border-accent" data-id="element-435">
      <div className="absolute top-6 right-8 text-gray-500/20" data-id="element-436">
        <Quote size={48} fill="currentColor" data-id="element-437" />
      </div>

      <div className="flex items-center gap-4 mb-6" data-id="element-438">
        <img src={image} alt={name} className="w-16 h-16 rounded-full object-cover border-2 border-gray-500" data-id="element-439" />
        <div data-id="element-440">
          <h4 className="font-bold text-white text-lg" data-id="element-441">{name}</h4>
          <div className="flex text-yellow-400" data-id="element-442">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-443" />)}
          </div>
        </div>
      </div>

      <p className="text-gray-300 italic leading-relaxed flex-grow" data-id="element-444">"{text}"</p>
    </div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Cindy Paredes',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/2018/12/Cindy-Paredes.jpg',
    text: 'Not students of Master Sergio Hernandez but my kids had the pleasure to cross train twice at this school and I highly recommend it. Discipline is definitely shown not only by the Master of course, but by the courteous students. He seems very patient but strict which is what you want from a Tae Kwon Do master. If you live in the area, you should definitely check it out.'
  }, {
    name: 'Stephanie Maria',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/2018/12/Stephanie-Maria.jpg',
    text: "Great school! Well maintained and clean. You can really tell Instructor Sergio's passion for Tae Kwon Do. What I love most is his love for all his students! Highly recommend Hdz-Dragon !!"
  }, {
    name: 'Jesus A. Galvan',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/2018/12/Jesus-A.-Galvan.jpg',
    text: 'Great TKD school with highly disciplined students, I like the direction and vision that Master Sergio Hernandez is taking His school and students. All who join will greatly benefit from His teaching!'
  }];
  return <section className="py-20 bg-nav text-white relative overflow-hidden" data-id="element-445">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-446"></div>

      <Container className="relative z-10" data-id="element-447">
        <div className="text-center mb-16" data-id="element-448">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 uppercase tracking-tight font-heading" data-id="element-449">
            Customer Reviews
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto mb-6" data-id="element-450"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-451">
          {testimonials.map((item, index) => <TestimonialCard key={index} {...item} data-id="element-452" />)}
        </div>

        <div className="text-center" data-id="element-453">
          <p className="text-gray-400 mb-6" data-id="element-454">
            For a complete listing of customer reviews, please click on the
            buttons below!
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10" data-id="element-455">
            <a href="https://search.google.com/local/writereview?placeid=ChIJ34Lf4rJ5D4gRVht1_8Xa3io" target="_blank" rel="noopener noreferrer" data-id="element-456">
              <Button variant="secondary" className="w-full sm:w-auto" data-id="element-457">
                Leave a Google Review
              </Button>
            </a>
            <a href="https://www.facebook.com/HdzYongdragonTKD/" target="_blank" rel="noopener noreferrer" data-id="element-458">
              <Button variant="primary" className="w-full sm:w-auto bg-[#1877F2] hover:bg-[#166fe5]" data-id="element-459">
                Leave a Facebook Review
              </Button>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-460">
            <a href="#signup" data-id="element-461">
              <Button variant="primary" size="lg" className="shadow-lg shadow-red-900/30" data-id="element-462">
                Get One Week Free Trial
              </Button>
            </a>
            <a href="tel:8472128045" data-id="element-463">
              <Button variant="secondary" size="lg" data-id="element-464">
                Call (847) 212-8045
              </Button>
            </a>
          </div>
        </div>
      </Container>
    </section>;
}